import React, { useState, useRef, useEffect, Suspense, lazy } from 'react';
import '../../style/avaliacao.css';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Alert from 'react-bootstrap/Alert';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Tab from 'react-bootstrap/Tab';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import api from '../../redux/actions/configApi';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCategories, clearSuccessMessage } from '../../redux/reducers/categoriesSlice'; // Importa o thunk
import Loader from '../../components/loading';
const FormularioMarca = lazy(() => import('../Painel/FormulariosAvaliacao/marca'));
const FormularioTipo = lazy(() => import('../Painel/FormulariosAvaliacao/tipo'));
const FormularioCaracteristicas = lazy(() => import('../Painel/FormulariosAvaliacao/caracteristica'));
const PaginationComponent = lazy(() => import('../../components/paginacao'));
const DynamicForm = () => {

    const [key, setKey] = useState('modelos');
    const [data, setData] = useState([]);
    const [brand, setBrand] = useState('');
    const [brandEdit, setBrandEdit] = useState('');
    const [model, setModel] = useState('');
    const [modelEdit, setModelEdit] = useState('');
    const [modelEditName, setModelEditName] = useState('');
    const [tipo, setTipo] = useState('');
    const [tipoEdit, setTipoEdit] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [attributes, setAttributes] = useState([]);
    const [attributesEditAux, setAttributesEditAux] = useState([]);
    const [dataModel, setDataModel] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showModalVisu, setShowModalVisu] = useState(false);
    const [valorBase, setValorBase] = useState('');
    const [valorBaseEdit, setValorBaseEdit] = useState('');
    const [selectedModel, setSelectedModel] = useState(null); // Armazena o modelo selecionado para visualização
    const [showEditModal, setShowEditModal] = useState(false);
    const [previewImage, setPreviewImage] = useState(null); // Estado para armazenar a pré-visualização
    const [base64Image, setBase64Image] = useState(""); // Estado para armazenar a imagem em base64
    const [previewImageEdit, setPreviewImageEdit] = useState(null); // Estado para armazenar a pré-visualização
    const [base64ImageEdit, setBase64ImageEdit] = useState(""); // Estado para armazenar a imagem em base64
    const [imageVisu, setImageVisu] = useState(""); // Estado para armazenar a imagem em base64
    const [errors, setErrors] = useState({}); // Estado separado para armazenar erros
    const [orderEdit, setOrderEdit] = useState(""); // Estado para armazenar a imagem em base64
    const [selectedClassification, setSelectedClassification] = useState(); // Set initial value
    const [selectedClassificationEdit, setSelectedClassificationEdit] = useState(); // Set initial value
    const dispatch = useDispatch();
    const classificationOptions = [
        { value: 1, label: 'Avaliador' },
        { value: 3, label: 'Avaliador/Ecommerce' }
    ];
    const { valores, brandApi, successMessage } = useSelector((state) => state.categories);
    const [ordem, setValorOrdem] = useState();
    const errorRefs = useRef({}); // Usando um objeto para armazenar referências
    //************************************************cadastro
    //Paginação
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Define quantos itens serão exibidos por página
    const totalPages = Math.ceil(dataModel.length / itemsPerPage);
    const getCurrentPageItems = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        return dataModel.slice(startIndex, endIndex);
    }
    const handleClassificationChange = (event) => {
        setSelectedClassification(event.target.value);
    };
    const handleClassificationChangeEdit = (event) => {
        setSelectedClassificationEdit(event.target.value);
    };
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };
    //setMarca
    const handleBrandChange = (e) => {
        setBrand(e.target.value);
        setTipo('');
        setModel('');
    };
    const handleTipoChange = (e) => {
        setTipo(e.target.value);
        setModel('');
    };
    //atualização atributos cadastros
    const handleAttributeChange = (attributeId, attributeValueId, key, value) => {
        setAttributes((prevAttributes) =>
            prevAttributes.map((attr) => {
                if (attr.id === attributeId) {
                    return {
                        ...attr,
                        attribute_values: attr.attribute_values.map((val) => {
                            if (val.id === attributeValueId) {
                                return {
                                    ...val,
                                    [key]: value, // Atualiza o valor do campo específico (valor ou tipo de modificação)
                                };
                            }
                            return val;
                        }),
                    };
                }
                return attr;
            })
        );
    };
    //submissao cadastro
    const handleSubmit = async (e) => {
        e.preventDefault();
        let isValid = true;
        const newErrors = {}; // Para armazenar os erros temporariamente
        attributes.forEach((attribute) => {
            attribute.attribute_values.forEach((value) => {
                // Verifica se a checkbox está marcada antes de validar os campos
                if (value.active) {
                    // Se estiver ativa, validar priceValue e priceType
                    if (!value.priceValue || !value.priceType) {
                        isValid = false;
                        newErrors[value.id] = "Informe se o valor será um acréscimo ou abatimento!"; // Mensagem de erro se faltar valor ou tipo
                    }
                } else {
                    // Se a checkbox não estiver ativa, garantir que o erro seja removido
                    if (errors[value.id]) {
                        delete errors[value.id]; // Remove o erro associado
                    }
                }
            });
        });
        if (!isValid) {
            setErrors(newErrors); // Atualiza o estado de erros
            return;
        }
        const selectedAttributes = attributes
            .map((attr, index) => ({
                id: attr.id,
                name: attr.name,
                order: index + 1, // Adiciona a ordem ao objeto do atributo
                attributeList: attr.attribute_values
                    .filter((val) => val.active) // Somente valores ativos
                    .map((val) => ({
                        id: val.id,
                        value: val.value,
                        peso: val.priceValue,
                        modificationType: val.priceType,
                    })),
            }))
            .filter((attr) => attr.attributeList.length > 0); // Filtra apenas os atributos com valores ativos
        const formData = {
            brand,
            model,
            ordem,
            tipo,
            valorBase,
            selectedAttributes,
            base64Image, // Inclui a imagem em base64 nos dados enviados
            selectedClassification
        };
        setBrand('');
        setModel('');
        try {
            setLoading(true);
            setError(false);
            const response = await api.post('/api/avaliacoes', JSON.stringify(formData)) // Seu endpoint para salvar a avaliação
            //console.log(response.data, 'atributes new')
            setShowModal(false);
            setLoading(false);
            setSuccess(response.data.message)
            setDataModel(response.data.attributes)
            setAttributes([]);
        } catch (err) {
            // Verifica se há uma resposta da API e extrai a mensagem de erro
            if (err.response && err.response.data) {
                setShowModal(false);
                setSuccess(false)
                setError(err.response.data.message || 'Erro ao enviar os dados.');
            } else {
                setError('Falha ao enviar os dados. Tente novamente mais tarde.');
            }

        } finally {
            setLoading(false);
        }
    };
    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setBase64Image(reader.result); // Armazena a imagem em base64
                setPreviewImage(reader.result); // Mostra a pré-visualização
            };
            reader.readAsDataURL(file);
        }
    };
    //*************************************************visualizar
    const handleVisualizar = (model) => {
        console.log(model, 'model')
        setSelectedModel(model);
        setImageVisu(model.image_model)
        setShowModalVisu(true);
    }
    //******************************************************editar
    const handleBrandChangeEdit = (e) => {
        // alert(e.target.value,'e.target.value')
        setBrandEdit(e.target.value);
        setTipoEdit('');
        setModel('');
    };
    const handleOrderAndUpdateAttributes = (model) => {
        // Faz uma cópia profunda dos atributos
        const updatedAttributes = attributesEditAux.map(attribute => ({
            ...attribute,
            attribute_values: attribute.attribute_values.map(value => ({ ...value })),
        }));

        // Atualiza cada atributo
        updatedAttributes.forEach((attribute, index) => {
            // Verificar se model.attributes existe e tem o atributo com o nome correspondente
            const selectedAttribute = model.attributes?.[attribute.name];

            if (selectedAttribute) {
                console.log(selectedAttribute, 'selectedAttribute')
                attribute.attribute_values = attribute.attribute_values.map((value) => {
                    // Encontra o valor correspondente no selectedAttribute
                    const matchingValue = selectedAttribute.valores?.find(
                        (v) => v.id === value.id
                    );

                    if (matchingValue) {
                        return {
                            ...value,
                            active: true,
                            priceValue: matchingValue.peso || value.priceValue, // Mantém o valor atual se não for encontrado
                            tipo: matchingValue.modification_type || value.tipo, // Mantém o tipo atual se não for encontrado
                        };
                    } else {
                        return {
                            ...value,
                            active: false,
                            priceValue: '',
                            tipo: '',
                        };
                    }
                });
            } else {
                // Limpa o atributo caso não haja `selectedAttribute` correspondente
                attribute.attribute_values = attribute.attribute_values.map((value) => ({
                    ...value,
                    active: false,
                    priceValue: '',
                    tipo: '',
                }));
            }
        });
        setAttributesEditAux(updatedAttributes);
    };
    //atualizar modal
    const handleOpenEditModal = (model) => {
        setBrandEdit(model.brands_id); // Ajusta o valor de brand para o que está em model.marca
        setTipoEdit(model.type_id); // Ajusta o valor de brand para o que está em model.marca
        setModelEdit(model.model_id)
        setModelEditName(model.model_name)
        setOrderEdit(model.ordem)
        setValorBaseEdit(model.valor_base)
        setPreviewImageEdit(model.image_model)
        setShowEditModal(true);
        handleOrderAndUpdateAttributes(model)
    };
    ///selecao edicao
    const handleAttributeChangeEdit = (attributeId, attributeValueId, key, value) => {
        setAttributesEditAux((prevAttributes) =>
            prevAttributes.map((attr) => {
                if (attr.id === attributeId) {
                    return {
                        ...attr,
                        attribute_values: attr.attribute_values.map((val) => {
                            if (val.id === attributeValueId) {
                                return {
                                    ...val,
                                    [key]: value, // Atualiza o valor do campo específico (valor ou tipo de modificação)
                                };
                            }
                            return val;
                        }),
                    };
                }
                return attr;
            })
        );
    };
    const handleSubmitEdit = async (e) => {
        e.preventDefault();
        const selectedAttributesEdit = attributesEditAux
            .map((attr, index) => ({
                id: attr.id,
                name: attr.name,
                order: index + 1, // Adiciona a ordem ao objeto do atributo
                attributeList: attr.attribute_values
                    .filter((val) => val.active) // Somente valores ativos
                    .map((val) => ({
                        id: val.id,
                        value: val.value,
                        peso: val.priceValue,
                        modificationType: val.tipo,
                    })),
            }))
            .filter((attr) => attr.attributeList.length > 0); // Filtra apenas os atributos com valores ativos
        const formData = {
            brandEdit,
            modelEdit,
            modelEditName,
            tipoEdit,
            orderEdit,
            base64ImageEdit,
            valorBaseEdit,
            selectedAttributesEdit,
            selectedClassificationEdit
        };
        setBrand('');
        setModel('');
        try {
            setLoading(true);
            setError(false);
            const response = await api.put('avaliacaoUpdate', JSON.stringify(formData)) // Seu endpoint para salvar a avaliação
            setShowEditModal(false);
            setLoading(false);
            setSuccess(response.data.message)
            setDataModel(response.data.attributes)
            setBase64ImageEdit('')
        } catch (err) {
            setSuccess(false)
            setLoading(false);
            setShowEditModal(false);
            // Verifica se há uma resposta da API e extrai a mensagem de erro
            if (err.response && err.response.data) {
                // Verifica se a mensagem de erro é uma string ou um array
                const errorMessage = err.response.data.message;
                if (Array.isArray(errorMessage)) {
                    // Se for um array, une as mensagens
                    setError(errorMessage.join(' '));
                } else {
                    // Se for uma string, apenas exibe
                    setError(errorMessage || 'Erro ao enviar os dados.');
                }
            } else {
                setError('Falha ao enviar os dados. Tente novamente mais tarde.');
            }

        } finally {
            //setLoading(false);
        }
    };
    //delete
    const handleDelete = async (id) => {
        const confirmDelete = window.confirm("Tem certeza que deseja excluir esta avaliacao?");
        if (!confirmDelete) return;
        setLoading(true);
        // console.log(id, 'id')
        try {
            const response = await api.delete(`avaliacaoDelete/${id}`);
            setLoading(false);
            setSuccess(response.data.message)
            setDataModel(response.data.attributes)
            // fetchTypes(); // Atualiza a tabela após a exclusão
        } catch (error) {
            console.error('Erro ao deletar tipo', error);
        } finally {
            setLoading(false);
        }
    };
    const handleImageUploadEdit = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setBase64ImageEdit(reader.result); // Armazena a imagem em base64
                setPreviewImageEdit(reader.result); // Mostra a pré-visualização
            };
            reader.readAsDataURL(file);
        }
    };
    //**************************************carregamentos da api
    useEffect(() => {
        dispatch(fetchCategories()); // Busca os dados ao montar o componente
    }, [dispatch]);

    useEffect(() => {
        // Para monitorar as alterações de attributes e atualizar os estados de edição
        setAttributesEditAux(valores);
        setAttributes(valores)
        setData(brandApi)
    }, [valores]);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)
            const response = await api.get('evaluationsAll');
            setDataModel(response.data.attributes);
            setLoading(false)
        };

        fetchData();
    }, []);

    useEffect(() => {
        const errorKeys = Object.keys(errors);
        if (errorKeys.length > 0 && showModal) {
            const firstErrorKey = errorKeys[0];
            if (errorRefs.current[firstErrorKey]) {
                // Rolando para a primeira mensagem de erro encontrada
                errorRefs.current[firstErrorKey].scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    }, [errors, showModal]);

    useEffect(() => {
        if (successMessage) {
            const timer = setTimeout(() => {
                dispatch(clearSuccessMessage()); // Dispara a ação para limpar a mensagem
            }, 3000);
            // Limpa o temporizador se o componente desmontar ou se a mensagem mudar
            return () => clearTimeout(timer);
        }
    }, [successMessage, dispatch]);

    useEffect(() => {
        setValorOrdem(dataModel.length + 1)
    }, [dataModel])

    function FormularioModelos() {
        return (
            <div>
                {success && (
                    <Alert className="text-center " variant="success">
                        {success}
                        <Button className="m-3" variant="close" onClick={() => setSuccess(null)}>

                        </Button>
                    </Alert>
                )}
                {error && (
                    <Alert className="text-center " variant="danger">
                        {error}
                        <Button className="m-3" variant="close" onClick={() => setError(null)}>

                        </Button>
                    </Alert>
                )}
                <div className={`loading ${loading ? 'loading-active' : ''}`}>
                    <Loader loading={loading} /> {/* Exibe o loader se estiver carregando */}
                    <div className="d-flex justify-content-end mb-3">
                        <Button variant="primary" className='botao-acao' onClick={() => setShowModal(true)}>
                            Adicionar Modelo
                        </Button>
                    </div>
                    <div className='d-flex justify-content-center'>
                        <Suspense>
                            <PaginationComponent
                                currentPage={currentPage}
                                lastPage={totalPages}
                                onPageChange={handlePageChange}
                            />
                        </Suspense>
                    </div>
                    <Table bordered hover responsive className='tabela-painel text-center' style={{ fontSize: '0.7em' }}>
                        <thead>
                            <tr className='cabecalho-tabela'>
                                <th>Ordem</th>
                                <th>Marca</th>
                                <th>Tipo</th>
                                <th>Preço Base</th>
                                <th>Modelo</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {getCurrentPageItems().map((item) => (
                                <tr key={item.id} className='celula-tabela'>
                                    <td>{item.ordem}</td>
                                    <td>{item.marca}</td>
                                    <td>{item.tipo}</td>
                                    <td>{item.valor_base}</td>
                                    <td>{item.model_name}</td>
                                    <td>
                                        <Button variant="info" size="sm" className="me-2 botao-acao visualizar" onClick={() => handleVisualizar(item)} >Visualizar</Button>
                                        <Button variant="warning" size="sm" className="me-2 botao-acao alterar-status" onClick={() => handleOpenEditModal(item)}>Editar</Button>
                                        <Button variant="danger" size="sm" className='botao-acao' onClick={() => handleDelete(item.model_id)}> Deletar</Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </div>
        );
    }
    return (
        <Container>
            <Row>
                <h2 className='text-center titulo-pagina'><i style={{ color: '#ff7a00' }} className="fas fa-chart-line"></i> Cadastro de Avaliações</h2>
                <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                    <div className='nav-avaliacao'>
                        <Navbar expand="lg">
                            <Nav className="mr-auto">
                                <Nav.Link eventKey="marcas" onClick={() => setKey('marcas')}><i className="fas fa-copyright"></i> Marcas</Nav.Link>
                                <Nav.Link eventKey="tipos" onClick={() => setKey('tipos')}><i className="fas fa-filter"></i> Tipos</Nav.Link>
                                <Nav.Link eventKey="caracteristicas" onClick={() => setKey('caracteristicas')}> <i className="fas fa-sliders-h"></i> Características</Nav.Link>
                                <Nav.Link eventKey="modelos" onClick={() => setKey('modelos')}> <i className="fas fa-puzzle-piece"></i> Modelos</Nav.Link>
                            </Nav>
                        </Navbar>
                    </div>
                </Tab.Container>
                <Tab.Content>
                    <Tab.Pane eventKey="marcas" active={key === 'marcas'}>
                        <Suspense>
                            {key === 'marcas' && <FormularioMarca />}
                        </Suspense>
                    </Tab.Pane>
                    <Tab.Pane eventKey="tipos" active={key === 'tipos'}>
                        <Suspense>
                            {key === 'tipos' && <FormularioTipo />}
                        </Suspense>
                    </Tab.Pane>
                    <Tab.Pane eventKey="caracteristicas" active={key === 'caracteristicas'}>
                        <Suspense>
                            {key === 'caracteristicas' && <FormularioCaracteristicas />}
                        </Suspense>
                    </Tab.Pane>
                    <Tab.Pane eventKey="modelos" active={key === 'modelos'}>
                        <Suspense>
                            {key === 'modelos' && <FormularioModelos />}
                        </Suspense>
                    </Tab.Pane>
                </Tab.Content>

            </Row>
            {/*Modal de Visualizacao*/}
            <Modal show={showModalVisu} onHide={() => setShowModalVisu(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title className='w-100 text-center titulo-modal'>Visualizar Modelo</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col lg={12} className='d-flex justify-content-center'>
                            <img src={imageVisu} alt="Pré-visualização" style={{ maxWidth: '100%', height: '25vh' }} />
                        </Col>
                    </Row>
                    {selectedModel?.attributes && Object.keys(selectedModel?.attributes).map((attributeKey) => {
                        const attribute = selectedModel.attributes[attributeKey];
                        return (
                            <div key={attributeKey} style={{ margin: '10px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', borderLeft: '5px solid #F3A52C', marginBottom: '20px', padding: '0px 0px 0px 15px', borderRadius: '10px' }}>
                                <h5>{attributeKey}</h5>
                                {attribute?.valores?.map((valor, index) => (
                                    <div key={index} style={{ margin: '10px' }}>
                                        <Form.Group as={Row}>
                                            <Form.Label column sm="3">Peso</Form.Label>
                                            <Col md="4" sm="6">
                                                <Form.Control type="text" value={valor.peso} readOnly />
                                            </Col>
                                            <Col md="4" sm="6" className="d-flex justify-content-center">
                                                <ButtonGroup>
                                                    <Button
                                                        variant={valor.modification_type === 'acrescimo' ? 'success' : 'outline-success'}
                                                        disabled
                                                        style={{ margin: '5px' }}
                                                    >
                                                        +
                                                    </Button>
                                                    <Button
                                                        variant={valor.modification_type === 'abatimento' ? 'danger' : 'outline-danger'}
                                                        disabled
                                                    >
                                                        -
                                                    </Button>
                                                </ButtonGroup>
                                            </Col>
                                        </Form.Group>
                                    </div>
                                ))}
                            </div>
                        );
                    })}
                </Modal.Body>
            </Modal>
            {/*edicao*/}
            <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title className='w-100 text-center titulo-modal'>Editar Modelo</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmitEdit}>
                        <Row>
                            <Form.Group as={Col} md="12" className="mt-3">
                                <Form.Label htmlFor="editImageUpload">Alterar Imagem:</Form.Label>
                                <Form.Control
                                    type="file"
                                    id="editImageUpload"
                                    accept="image/*"
                                    onChange={handleImageUploadEdit} // Reutiliza a função de upload
                                />
                                {previewImageEdit && (
                                    <div className="mt-3 text-center">
                                        <img src={previewImageEdit} alt="Pré-visualização" style={{ maxWidth: '100%', height: '25vh' }} />
                                    </div>
                                )}
                            </Form.Group>
                        </Row>
                        <Row>
                            <Form.Group as={Col} md="6">
                                <Form.Label htmlFor="brand">Marca:</Form.Label>
                                <Form.Select
                                    id="brand"
                                    value={brandEdit}
                                    onChange={handleBrandChangeEdit}
                                    required
                                    className="form-control"
                                >
                                    <option value="">Selecione uma marca</option>
                                    {data.map((brand) => (
                                        <option key={brand.id} value={brand.id}>
                                            {brand.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                            <Form.Group as={Col} md="6">
                                <Form.Label htmlFor="tipo">Tipo:</Form.Label>
                                <Form.Select
                                    id="tipo"
                                    value={tipoEdit}
                                    onChange={handleTipoChange}
                                    disabled={!brandEdit}
                                    required
                                    className="form-control"
                                >
                                    <option value="">Selecione um tipo</option>
                                    {brandEdit &&
                                        data
                                            .find((b) => b.id === parseInt(brandEdit))
                                            ?.types.map((tipo) => (
                                                <option key={tipo.id} value={tipo.id}>
                                                    {tipo.name}
                                                </option>
                                            ))}
                                </Form.Select>
                            </Form.Group>
                        </Row>
                        <Row>
                            <Form.Group as={Col} md="6">
                                <Form.Label htmlFor="valorBase">Modelo:</Form.Label>
                                <Form.Control
                                    type="text"
                                    id="model"
                                    value={modelEditName}
                                    disabled={!tipoEdit}
                                    onChange={(e) => setModelEditName(e.target.value)}
                                    placeholder="Ex: modelo do aparelho"
                                    required
                                />
                            </Form.Group>
                            <Form.Group as={Col} md="6">
                                <Form.Label htmlFor="valorBase">Valor Base:</Form.Label>
                                <Form.Control
                                    type="text"
                                    id="valorBase"
                                    value={valorBaseEdit}
                                    onChange={(e) => setValorBaseEdit(e.target.value)}
                                    placeholder="Ex: valor base do aparelho"
                                    required
                                />
                            </Form.Group>
                        </Row>
                        <Row>
                            <Form.Group as={Col} md="6" className="mt-3">
                                <Form.Label htmlFor="ordem">Ordem</Form.Label>
                                <Form.Control
                                    type="text"
                                    id="ordem"
                                    value={orderEdit}
                                    onChange={(e) => setOrderEdit(e.target.value)}
                                    placeholder="Ex: Ordem de exibição"
                                    required
                                />
                            </Form.Group>
                            <Form.Group as={Col} md="6" className="mt-3">
                                <Form.Label htmlFor="classificacao">Classificação:</Form.Label>
                                <Form.Select
                                    id="classificacao"
                                    value={selectedClassificationEdit}
                                    onChange={handleClassificationChangeEdit}
                                    required
                                    className="form-control"
                                >
                                    {classificationOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Row>
                        <div className="mt-3">
                            <h4 className='mb-3 mt-3 text-center'>Atributos</h4>
                            {(attributesEditAux ?? []).map((valor) => {
                                return (
                                    <div key={valor.id} className="mb-3" style={{ margin: '10px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', borderLeft: '5px solid #F3A52C', marginBottom: '20px', padding: '0px 0px 0px 15px', borderRadius: '10px' }}>
                                        <Row className="align-items-center">
                                            <Col md="8">
                                                <h5>{valor.name}</h5>
                                            </Col>
                                        </Row>
                                        {valor?.attribute_values?.map((value) => {
                                            // Verificar se o valor já está no editModel
                                            return (
                                                <Row key={value.id} className="mb-2">
                                                    <Col md="4">
                                                        <Form.Check
                                                            type="checkbox"
                                                            label={value.value}
                                                            checked={value.active}
                                                            onChange={(e) =>
                                                                handleAttributeChangeEdit(valor.id, value.id, 'active', e.target.checked)
                                                            }
                                                        />
                                                    </Col>
                                                    <Col md="4">
                                                        <Form.Control
                                                            type="text"
                                                            required
                                                            value={value.priceValue}
                                                            disabled={!value.active}
                                                            placeholder="Valor"
                                                            onChange={(e) =>
                                                                handleAttributeChangeEdit(valor.id, value.id, 'priceValue', e.target.value)
                                                            }
                                                        />
                                                    </Col>
                                                    <Col md="4" className='d-flex justify-content-center'>
                                                        <ButtonGroup >
                                                            <Button
                                                                id={`botao-editar-${value.id}-acrescimo`}
                                                                required={value.active}
                                                                variant={value.tipo === 'acrescimo' ? 'success' : 'outline-success'}
                                                                disabled={!value.active}
                                                                style={{ margin: '5px' }}
                                                                onClick={() =>
                                                                    handleAttributeChangeEdit(valor.id, value.id, 'tipo', 'acrescimo')
                                                                }
                                                            >
                                                                +
                                                            </Button>
                                                            <Button
                                                                id={`botao-editar-${value.id}-abatimento`}
                                                                required={value.active}
                                                                variant={value.tipo === 'abatimento' ? 'danger' : 'outline-danger'}
                                                                disabled={!value.active}
                                                                onClick={() =>
                                                                    handleAttributeChangeEdit(valor.id, value.id, 'tipo', 'abatimento')
                                                                }
                                                            >
                                                                -
                                                            </Button>
                                                        </ButtonGroup>
                                                    </Col>
                                                </Row>
                                            );
                                        })}
                                    </div>
                                );
                            })}
                        </div>
                        <Button type="submit" disabled={loading}>
                            {loading ? 'Salvando...' : 'Atualizar'}
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
            {/* Visualizar cadastro */}
            <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title className='w-100 text-center titulo-modal'>Adicionar Modelo</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Form.Group as={Col} md="12" className="mt-3">
                                <Form.Label htmlFor="imageUpload">Upload de Imagem:</Form.Label>
                                <Form.Control
                                    type="file"
                                    id="imageUpload"
                                    accept="image/*"
                                    onChange={handleImageUpload} // Função para lidar com o upload e conversão para base64

                                />
                                {previewImage && ( // Se houver uma imagem para pré-visualizar
                                    <div className="mt-3 text-center">
                                        <img src={previewImage} alt="Pré-visualização" style={{ maxWidth: '100%', height: '25vh' }} />
                                    </div>
                                )}
                            </Form.Group>
                        </Row>
                        <Row>
                            <Form.Group as={Col} md="6">
                                <Form.Label htmlFor="brand">Marca:</Form.Label>
                                <Form.Select
                                    id="brand"
                                    value={brand}
                                    onChange={handleBrandChange}
                                    required
                                    className='form-control'
                                >
                                    <option value="">Selecione uma marca</option>
                                    {data.map((brand) => (
                                        <option key={brand.id} value={brand.id}>
                                            {brand.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                            <Form.Group as={Col} md="6">
                                <Form.Label htmlFor="tipo">Tipo:</Form.Label>
                                <Form.Select
                                    id="tipo"
                                    value={tipo}
                                    onChange={handleTipoChange}
                                    disabled={!brand}
                                    required
                                    className='form-control'
                                >
                                    <option value="">Selecione um tipo</option>
                                    {brand && data.find((b) => b.id === parseInt(brand))?.types.map((tipo) => (
                                        <option key={tipo.id} value={tipo.id}>
                                            {tipo.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Row>
                        <Row>
                            <Form.Group as={Col} md="6">
                                <Form.Label htmlFor="valorBase">Modelo:</Form.Label>
                                <Form.Control
                                    type="text"
                                    id="model"
                                    value={model}
                                    disabled={!tipo}
                                    onChange={(e) => setModel(e.target.value)}
                                    placeholder="Ex: modelo do aparelho"
                                    required
                                />
                            </Form.Group>

                            <Form.Group as={Col} md="6">
                                <Form.Label htmlFor="valorBase">Valor Base:</Form.Label>
                                <Form.Control
                                    type="text"
                                    id="valorBase"
                                    value={valorBase}
                                    onChange={(e) => setValorBase(e.target.value)}
                                    placeholder="Ex: valor base do aparelho"
                                    required
                                />
                            </Form.Group>
                        </Row>
                        <Row>
                            <Form.Group as={Col} md="6" className="mt-3">
                                <Form.Label htmlFor="ordem">Ordem</Form.Label>
                                <Form.Control
                                    type="text"
                                    id="ordem"
                                    value={ordem}
                                    onChange={(e) => setValorOrdem(e.target.value)}
                                    placeholder="Ex: Ordem de exibição"
                                    required
                                />
                            </Form.Group>
                            <Form.Group as={Col} md="6" className="mt-3">
                                <Form.Label htmlFor="classificacao">Classificação:</Form.Label>
                                <Form.Select
                                    id="classificacao"
                                    value={selectedClassification}
                                    onChange={handleClassificationChange}
                                    required
                                    className="form-control"
                                >
                                    {classificationOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Row>
                        {/* Listagem dos Atributos */}
                        <div className="mt-3">
                            <h4 className='mt-3 mb-3 text-center'>Atributos</h4>
                            {(attributes ?? []).map((attribute, index) => (
                                <div key={attribute.id} className="mb-3" style={{ margin: '10px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', borderLeft: '5px solid #F3A52C', marginBottom: '20px', padding: '0px 0px 0px 15px', borderRadius: '10px' }}>
                                    <Row className="align-items-center" >
                                        <Col md="8">
                                            <h5>{attribute.name}</h5>
                                        </Col>
                                    </Row>
                                    {attribute.attribute_values.map((index) => (
                                        <Row key={index.id} className="mb-2" ref={(el) => (errorRefs.current[index.id] = el)} >
                                            <Col md="4">
                                                <Form.Check
                                                    type="checkbox"
                                                    label={index.value}
                                                    checked={index.active}
                                                    onChange={(e) =>
                                                        handleAttributeChange(attribute.id, index.id, 'active', e.target.checked)
                                                    }
                                                />
                                            </Col>
                                            <Col md="4">
                                                <Form.Control
                                                    type="text"
                                                    required
                                                    placeholder="Valor"
                                                    disabled={!index.active}
                                                    value={index.priceValue || ''} // Previne valores undefined
                                                    onChange={(e) =>
                                                        handleAttributeChange(attribute.id, index.id, 'priceValue', e.target.value)
                                                    }
                                                />
                                            </Col>
                                            <Col md="4" className='d-flex justify-content-center'>
                                                <ButtonGroup>
                                                    <Button
                                                        required={index.active}
                                                        variant={index.priceType === 'acrescimo' ? 'success' : 'outline-success'}
                                                        disabled={!index.active}
                                                        style={{ margin: '5px' }}
                                                        onClick={() =>
                                                            handleAttributeChange(attribute.id, index.id, 'priceType', 'acrescimo')
                                                        }
                                                    >
                                                        +
                                                    </Button>
                                                    <Button
                                                        required={index.active}
                                                        variant={index.priceType === 'abatimento' ? 'danger' : 'outline-danger'}
                                                        disabled={!index.active}
                                                        onClick={() =>
                                                            handleAttributeChange(attribute.id, index.id, 'priceType', 'abatimento')
                                                        }
                                                    >
                                                        -
                                                    </Button>

                                                </ButtonGroup>
                                            </Col>
                                            <div className='text-center' >
                                                {errors[index.id] && (
                                                    <div className="text-danger">{errors[index.id]}</div> // Exibe a mensagem de erro
                                                )}

                                            </div>
                                        </Row>
                                    ))}
                                </div>
                            ))}
                        </div>
                        <Button type="submit" disabled={loading}>
                            {loading ? 'Salvando...' : 'Salvar'}
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </Container >
    );
};
export default DynamicForm;
